import { documentConstants } from "../../constants";

const defaultState = {
  items: [],
  item: {},
  loadingItems: false,
  loadingItem: false,
  fetchedItems: false,
  fetchedItem: false,
  error: null
};

function normalData(arr) {
  if (!Array.isArray(arr)) return [];

  return arr.map((elem, index) => Object.assign(elem, {
    index: (index + 1),
    responsiblePersonLabel: typeof elem.responsiblePerson === 'object'
      ? elem.responsiblePerson?.firstName + " " + elem.responsiblePerson?.lastName
      : elem.responsiblePerson,
    responsiblePersonId: elem.responsiblePerson ? elem.responsiblePerson.id : null,
    storageLabel: typeof elem.storage === 'object'
      ? elem.storage?.nameStorage
      : elem.storage,
    storageId: elem.storage ? elem.storage.id : null,
  }));
}

export const inventoryReducer = function (state = defaultState, action) {
  switch (action.type) {
    case documentConstants.GETALL_REQUEST_INVENTORY:
      return {
        ...state,
        item: {},
        loadingItems: true,
        loadingItem: false,
        fetchedItems: false,
        fetchedItem: false,
        error: null
      };
    case documentConstants.GETALL_SUCCESS_INVENTORY:
      return {
        ...state,
        items: normalData(action.response),
        loadingItems: false,
        fetchedItems: true,
      };
    case documentConstants.GETALL_FAILURE_INVENTORY:
      return {
        ...state,
        loadingItems: false,
        fetchedItems: false,
        error: action.error,
      };

    case documentConstants.GETBYID_REQUEST_INVENTORY:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case documentConstants.GETBYID_SUCCESS_INVENTORY:
      const existingItem = state.items.find(item => item.id === action.response.id && item.viewStatus?.status !== action.response?.viewStatus?.status);
      if (existingItem) {
        return {
          ...state,
          items: state.items.map(item => {
            if (item.id !== action.response.id) {
              return item;
            }
            item.responsiblePersonLabel = action.response?.responsiblePerson?.firstName + " " + action.response?.responsiblePerson?.lastName;
            item.viewStatus = action.response?.viewStatus;
            return item;
          }),
          item: action.response,
          loadingItem: false,
          fetchedItem: true,
        };
      } else {
        return {
          ...state,
          item: action.response,
          loadingItem: false,
          fetchedItem: true,
        };
      }

    case documentConstants.GETBYID_FAILURE_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.CREATE_REQUEST_INVENTORY:
      return {
        ...state,
        item: {},
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case documentConstants.CREATE_SUCCESS_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        items: normalData(state.items.concat(action.response)),
        item: action.response,
      };
    case documentConstants.CREATE_FAILURE_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.UPDATE_REQUEST_INVENTORY:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null
      };
    case documentConstants.UPDATE_SUCCESS_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: true,
        item: action.response,
        items: normalData(state.items.map((elem) => {
          if (elem.id === action.response.id) return Object.assign(elem, { ...action.response });
          return elem;
        }))
      };
    case documentConstants.UPDATE_FAILURE_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        error: action.error,
      };

    case documentConstants.ARCHIVE_REQUEST_INVENTORY:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case documentConstants.ARCHIVE_SUCCESS_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        items: normalData(state.items.map((elem) => {
          if (elem.id === action.id) return Object.assign(elem, { ...action.response, isArchive: !elem.isArchive });
          return elem;
        }))
      };
    case documentConstants.ARCHIVE_FAILURE_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        error: action.error,
      };

    case documentConstants.DELETE_REQUEST_INVENTORY:
      return {
        ...state,
        loadingItem: true,
        fetchedItem: false,
        error: null,
      };
    case documentConstants.DELETE_SUCCESS_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        fetchedItem: false,
        items: normalData(state.items.filter(elem => elem.id !== action.id))
      };
    case documentConstants.DELETE_FAILURE_INVENTORY:
      return {
        ...state,
        loadingItem: false,
        error: action.error,
      };

    case "RESET_ITEM_INVENTORY":
      return {
        ...state,
        fetchedItem: false,
        loadingItem: false,
        item: {}
      };

    case "RESET_ITEMS_INVENTORY":
      return {
        ...state,
        fetchedItems: false,
        loadingItems: false,
        items: [],
        error: null
      };

    default:
      return state;
  }
};